import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Col, Row, Form } from "react-bootstrap";
import {
  BlockContentControls,
  ButtonCommon,
  ChipsControl,
  InputText,
  InputTextForm,
  ModalActionMessage,
  SelectGender,
  SelectSizeGuideType,
  SizesForm,
  SuggestionWidget,
} from "../../../common";
import {
  ISizeModel,
  IBodyPart,
  ISizeModelMeasure,
  ISizeGuide,
  E_ClothesType,
  E_GenderType,
  E_BodyPart,
  ISizeGuideCup,
} from "../../../common/types";
import { SizeGuideServices } from "../../../../services";
import "./EditSizeGuide.css";
import { FormattedMessage, useIntl } from "react-intl";
import { Tag } from "primereact/tag";
import { Tools } from "../../../../misc";
// import Tooltip from "../../../common/components/ToolTip";
import TooltipAlias from "../../../common/components/TooltipAlias";
import { InputSwitch } from "primereact/inputswitch";

const EditSizeGuide = (props: any) => {
  // const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [showModal, setShowModal] = useState(false);
  
  const intl = useIntl();

  if (Tools.IsDevelopment()) console.log("STATE HOOK", state);

  const clothesType = parseInt(state.TypeSizeGuide.Id);
  const [clothesTypeSelect, setClothesTypeSelect] = useState(
    parseInt(state.TypeSizeGuide.Id)
  );

  const gender = parseInt(state.Gender.Id);
  const [genreSelect, setGenreSelect] = useState(parseInt(state.Gender.Id));

  const unique = state.IsUnique;
  const [uniqueSelect, setUniqueSelect] = useState(state.IsUnique);

  const [cupSelect, setCupSelect] = useState<any[]>(
    state.Cups
      ? state.Cups.map((value: any) => {
          return value.Name;
        })
      : []
  );

  const [sizeGuideName, setSizeGuideName] = useState(state.Name);
    const [enabledChecked, setEnabledChecked] = useState(state.Enabled || true);

  const [formSizes, setFormSizes] = useState<ISizeModel[]>(state.Sizes);
  const [cupsSizes, setCupsSize] = useState<ISizeGuideCup[]>(
    state.Cups ? state.Cups : new Array<ISizeGuideCup>()
  );

  const [createProductGuideSelected, setCreateProductGuide] = useState(
    state.ProductReference ? true : false
  );
  const [
    productReferenceCodeDefaultValue,
    setProductReferenceCodeDefaultValue,
  ] = useState(state.ProductReference ? state.ProductReference : "");
  const [productReferenceCode, setProductReferenceCode] = useState(
    state.ProductReference ? state.ProductReference : ""
  );
  const [otherReference, setOtherReference] = useState<string[]>(
    state.OtherReference && state.OtherReference.length > 0
      ? state.OtherReference
      : new Array<string>()
  );
  const [inputValue, setInputValue] = useState("");
  const [isClicked, setIsClicked] = useState(false);
  const divRef = useRef<HTMLDivElement>(null);

  const handleClick = () => {
    setIsClicked(true);
  };

  const handleDocumentClick = (event: MouseEvent) => {
    if (divRef.current && !divRef.current.contains(event.target as Node)) {
      setIsClicked(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleDocumentClick);
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);


  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setInputValue(value);
  };

  const handleEnabledChange = (e: any) => {
    if ((Tools.CanCreateSizeGuide()) || (state.Enabled)) setEnabledChecked(e.value);
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const clipboardData = event.clipboardData;
    if (clipboardData) {
      const aliasReference = [...otherReference];

      const pastedText = clipboardData.getData("text/plain");

      let updatedData = pastedText; // Concatenate new data with existing data

      let elementsCopied = updatedData.split("\r\n");

      // Remove the last element if it's empty
      if (
        elementsCopied.length > 0 &&
        elementsCopied[elementsCopied.length - 1] === ""
      ) {
        elementsCopied.pop();
      }

      elementsCopied = elementsCopied.filter(Boolean); // Remove any empty elements

      elementsCopied.forEach((element) => {
        if (element.split("\t").length) {
          element.split("\t").forEach((item) => {
            if (item.split(",").length) {
              item.split(",").forEach((itemComma) => {
                if (itemComma) aliasReference.push(itemComma);
              });
            } else {
              if (item) aliasReference.push(item);
            }
          });
        } else {
          if (element) aliasReference.push(element);
        }
      });

      setOtherReference(aliasReference);

      // Reset the input after pasting
      setInputValue(""); // Set the input value to blank
    }
  };

  const renderInputs = () => {
    if (!otherReference) return null;

    // Split the pasted data into individual items
    let items = otherReference;

    // Filter items based on the inputValue
    let filteredItems = items.filter((item) =>
      item.toLowerCase().includes(inputValue.toLowerCase())
    );

    // Render a Tag for each filtered item
    return (
      <div className="tag-container">
        {filteredItems.map((item, index) => (
          <div key={index} className="tag-item">
            <Tag>
              <div className="flex align-items-center gap-2 editsizeguide-alias-tag">
                <span className="text-base">{item}</span>
                <i
                  className="pi pi-times text-xs"
                  onClick={() => handleTagDelete(index)}
                ></i>
              </div>
            </Tag>
          </div>
        ))}
      </div>
    );
  };

  const handleTagDelete = (indexToDelete: any) => {
    // Get a copy of the current items array
    let newItems = [...otherReference];

    // Remove the item at the specified index
    newItems.splice(indexToDelete, 1);

    // Update the state with the new data
    setOtherReference(newItems);
  };

  const getBodyParts = (type: number) => {
    let bodyParts: Array<IBodyPart> = new Array<IBodyPart>();

    try {
      if (type === E_ClothesType.TOP) {
        bodyParts.push({
          Id: E_BodyPart.CHEST,
          Name: intl.formatMessage({
            id: "edit-size-guide-contornoBusto",
            // defaultMessage: "Contorno de busto",
          }),
        });
        bodyParts.push({
          Id: E_BodyPart.WAIST,
          Name: intl.formatMessage({
            id: "edit-size-guide-contornoCintura",
            // defaultMessage: "Contorno de cintura",
          }),
        });
        bodyParts.push({
          Id: E_BodyPart.HIP,
          Name: intl.formatMessage({
            id: "edit-size-guide-contornoCadera",
            // defaultMessage: "Contorno de cadera",
          }),
        });
      } else {
        if (type === E_ClothesType.BOTTOM) {
          bodyParts.push({
            Id: E_BodyPart.WAIST,
            Name: intl.formatMessage({
              id: "edit-size-guide-contornoCintura",
              // defaultMessage: "Contorno de cintura",
            }),
          });
          bodyParts.push({
            Id: E_BodyPart.HIP,
            Name: intl.formatMessage({
              id: "edit-size-guide-contornoCadera",
              // defaultMessage: "Contorno de cadera",
            }),
          });
          bodyParts.push({
            Id: E_BodyPart.LEG,
            Name: intl.formatMessage({
              id: "edit-size-guide-altoTotal",
              // defaultMessage: "Alto total",
            }),
          });
        } else {
          if (type === E_ClothesType.ENTIRE) {
            bodyParts.push({
              Id: E_BodyPart.CHEST,
              Name: intl.formatMessage({
                id: "edit-size-guide-contornoBusto",
                // defaultMessage: "Contorno de busto",
              }),
            });
            bodyParts.push({
              Id: E_BodyPart.WAIST,
              Name: intl.formatMessage({
                id: "edit-size-guide-contornoCintura",
                // defaultMessage: "Contorno de cintura",
              }),
            });
            bodyParts.push({
              Id: E_BodyPart.HIP,
              Name: intl.formatMessage({
                id: "edit-size-guide-contornoCadera",
                // defaultMessage: "Contorno de cadera",
              }),
            });
            bodyParts.push({
              Id: E_BodyPart.LEG,
              Name: intl.formatMessage({
                id: "edit-size-guide-altoTotal",
                // defaultMessage: "Alto total",
              }),
            });
          } else if (type === E_ClothesType.SHOES) {
            // For shoes
            bodyParts.push({
              Id: E_BodyPart.FOOT,
              Name: intl.formatMessage({
                id: "edit-size-guide-pieIzquierdo",
                defaultMessage: "Largo de Pie",
              }),
            });
          } else {
            bodyParts.push({
              Id: E_BodyPart.CHEST,
              Name: intl.formatMessage({
                id: "edit-size-guide-contornoBusto",
                // defaultMessage: "Contorno de busto",
              }),
            });
            bodyParts.push({
              Id: E_BodyPart.UNDERBUST,
              Name: intl.formatMessage({
                id: "edit-size-guide-contornoBajoBusto",
                // defaultMessage: "Contorno de bajo busto",
              }),
            });
          }
        }
      }
    } catch (error) {
      console.log("GetBodyParts", error);
    }

    return bodyParts;
  };

  const getSizes = (partsBody: IBodyPart[], FormSizes: ISizeModel[] | []) => {
    let aSizes: Array<ISizeModel> = new Array<ISizeModel>();
    let newSize: ISizeModel;

    try {
      // console.log("GET SIZES COUNTER CHANGE", counterChangeSizes);
      // console.log("GET SIZES FORM SIZE", FormSizes);

      if (FormSizes && FormSizes.length > 0) {
        aSizes = [...FormSizes];
      } else {
        newSize = {
          Id: 0,
          Order: 1,
          Name: "",
          Measures: new Array<ISizeModelMeasure>(),
        };

        partsBody.forEach((item: IBodyPart, indexBodyPart: number) => {
          let RowMeasure: ISizeModelMeasure = {
            Id: item.Id,
            From: 0,
            ErrorFrom: false,
            To: 0,
            ErrorTo: false,
            IsSuccess: false,
            BodyPart: item,
          };

          newSize.Measures.push(RowMeasure);
        });

        aSizes.push(newSize);

        setFormSizes(aSizes);
      }
    } catch (error) {
      console.log("GET SIZES", error);
    }

    // console.log("GET SIZES", aSizes);

    return aSizes;
  };

  const onCheckProductGuideCreate = (value: any) => {
    try {
      setCreateProductGuide(value);

      if (value) {
        setProductReferenceCodeDefaultValue(
          `${sizeGuideName?.substr(0, 33).split(" ").join("-")}-rs-${Number(
            new Date()
          )}`
        );
        setProductReferenceCode(
          `${sizeGuideName?.substr(0, 33).split(" ").join("-")}-rs-${Number(
            new Date()
          )}`
        );
      } else {
        setProductReferenceCodeDefaultValue("");
        setProductReferenceCode("");
      }
    } catch (error) {
      console.log("ERROR ", error);
    }
  };

  const contentAttibrutes = () => {
    return (
      <>
        <Form>
          <div className="editsg-status-is-container">
            <label className="editsg-inputswitch-label">Estado</label>
            <InputSwitch checked={enabledChecked} onChange={handleEnabledChange} />
          </div>

          <InputTextForm
            Label="size-guide-guideName"
            Placeholder={"size-guide-enterGuideName"}
            MaxLength={25}
            DefaultValue={sizeGuideName}
            SuscribedChange={(value: string) => setSizeGuideName(value)}
          />
          <SelectSizeGuideType
            Label={
              <FormattedMessage
                id="ready-size-clothing-type"
                defaultMessage="Tipo de prenda"
              />
            }
            ClassGroup={"mt-3"}
            DefaultValue={clothesType}
            SuscribedChange={(value: number) => setClothesTypeSelect(value)}
          />
          <SelectGender
            Label="ready-size-gender"
            ClassGroup={"mt-3"}
            DefaultValue={gender}
            Disabled={clothesTypeSelect === E_ClothesType.BRASSIERE}
            SuscribedChange={(value: number) => setGenreSelect(value)}
          />
          <Form.Group
            className={`justify-content-center mt-3 ${
              clothesTypeSelect !== E_ClothesType.BRASSIERE
                ? "d-none"
                : "d-block"
            }`}
          >
            <ChipsControl
              Title={
                <FormattedMessage id="size-guide-cups" defaultMessage="Copas" />
              }
              Values={cupSelect}
              onChipChange={(e: any) => handlerCupChange(e)}
            />
          </Form.Group>
          <Form.Group
            className={`justify-content-center mt-3 ${
              clothesTypeSelect !== E_ClothesType.BRASSIERE
                ? "d-block"
                : "d-none"
            }`}
          >
            <Form.Check
              type="checkbox"
              label={
                <FormattedMessage
                  id="ready-size-unique-size"
                  defaultMessage="Talle único"
                />
              }
              onChange={(e) => setUniqueSelect(e.target.checked)}
              defaultChecked={unique}
              disabled={clothesTypeSelect === E_ClothesType.BRASSIERE}
            />
          </Form.Group>
          <Form.Group as={Row} className={`justify-content-center mt-3`}>
            <Col xs={4}>
              <Form.Check
                            type="checkbox"
                            label={intl.formatMessage({
                                id: "size-guide-createGuideProduct",
                                defaultMessage: "Crear producto guía",
                            })}
                            defaultChecked={createProductGuideSelected}
                            onChange={(e) => onCheckProductGuideCreate(e.target.checked)}
                            disabled={Tools.UserMustCreateRelatedCode()}
              />
            </Col>
            <Col xs={8}>
              <InputText
                Label={""}
                Placeholder={intl.formatMessage({
                  id: "size-guide-enterProductCode",
                  defaultMessage: "Ingresar el código del producto a generar",
                })}
                MaxLength={50}
                ClassName="ms-auto w-75 text-start"
                Disabled={((!(createProductGuideSelected)) || (Tools.UserMustCreateRelatedCode()))}
                DefaultValue={
                  !createProductGuideSelected
                    ? ""
                    : productReferenceCodeDefaultValue
                }
                SuscribedChange={(value: string) =>
                  setProductReferenceCode(value)
                }
              />
            </Col>
          </Form.Group>
        </Form>
      </>
    );
  };

  const contentSizes = () => {
    return (
      <>
        <SizesForm
          BodyParts={getBodyParts(clothesTypeSelect)}
          Elements={getSizes(getBodyParts(clothesTypeSelect), formSizes)}
          ClothesType={clothesTypeSelect}
          Cups={cupSelect}
          SucribeChanges={(e: ISizeModel[]) => handlerChangeForm(e)}
        />
      </>
    );
  };

  const contentAlias = () => {
    return (
      <>
        <div>
          <div>
            <div
              ref={divRef}
              onPaste={handlePaste}
              onClick={handleClick}
              className={`editsizeguide-alias-cp ${isClicked ? "clicked" : ""}`}
            >
              <FormattedMessage
                id="ready-size-paste"
                defaultMessage="Pega aquí tus alias"
              />
            </div>
            <p>
              <FormattedMessage
                id="ready-size-search-buscar"
                defaultMessage="Buscar"
              />
            </p>
            <input
              type="text"
              placeholder="Ej: Guia-Superior-Masculino"
              className="editsizeguide-custom-alias-input"
              value={inputValue}
              onChange={handleInputChange}
            />
          </div>
          <div
            className="tag-container"
            style={{ maxHeight: "400px", overflowY: "auto" }}
          >
            {renderInputs()}
          </div>
        </div>
      </>
    );
  };

  const handlerChangeForm = (Elements: ISizeModel[]) => {
    // FormSize = Elements;

    // console.log('HANDLER CHANGE FORM', Elements);

    setFormSizes(Elements);

    // setCounterChangeSize(counterChangeSizes + 1);
  };

  const handlerCupChange = (e: any) => {
    let aSizes: Array<ISizeModel> = new Array<ISizeModel>();
    let aCups: Array<ISizeGuideCup> = new Array<ISizeGuideCup>();
    let newCups: Array<ISizeGuideCup> = new Array<ISizeGuideCup>();
    let newSizes: Array<ISizeModel> = new Array<ISizeModel>();
    let newCup: ISizeGuideCup;

    try {
      // console.log("GET SIZES COUNTER CHANGE", counterChangeSizes);
      // console.log("GET SIZES FORM SIZE", FormSizes);

      // console.log("COPAS CHANGE", e);

      if (e) {
        if (cupsSizes && cupsSizes.length > 0) {
          aCups = [...cupsSizes];
        }

        if (aCups && aCups.length > e.length) {
          newCups = aCups.filter((value: ISizeGuideCup) => {
            return e.find((cup: string) => {
              return value.Name === cup;
            });
          });

          if (formSizes && formSizes.length > 0) {
            aSizes = [...formSizes];

            newSizes = aSizes.filter((value: ISizeModel) => {
              return e.find((cup: string) => {
                return value.Name.indexOf(cup) > -1;
              });
            });
          }

          // console.log('aCups CUPS CHANGE', aCups);
          // console.log('aSizes CUPS CHANGE', aSizes);

          // console.log('newCups CUPS CHANGE', newCups);
          // console.log('newSizes CUPS CHANGE', newSizes);

          if (newCups) setCupsSize(aCups);
          if (newSizes) setFormSizes(newSizes);
        } else {
          newCup = {
            Id: 0,
            Order: aCups[aCups.length - 1].Order + 1,
            Name: e[e.length - 1],
          };

          aCups.push(newCup);

          // console.log('aCups CUPS CHANGE', aCups);

          setCupsSize(aCups);

          // console.log('CUPS CHANGE ADD CUP');
        }
      }
    } catch (error) {
      console.log("ERROR CUPS CHANGE", error);
    } finally {
      setCupSelect(e);
    }
  };

  const onClickCancelar = () => {
    navigate(-1);
  };

  const onClickSave = async () => {
    let SizeGuide: ISizeGuide;

    try {
      SizeGuide = {
        Id: state.Id,
        Name: sizeGuideName,
        UnfixedLimits: state.UnfixedLimits,
        Cups: cupsSizes,
        TypeSizeGuide: { Id: clothesTypeSelect, Name: "" },
        Gender: { Id: genreSelect, Name: "" },
        IsUnique: uniqueSelect,
        Sizes: formSizes,
        ProductReference: createProductGuideSelected
          ? productReferenceCode
          : "",
        OtherReference: otherReference,
          Enabled: enabledChecked,
      };

      if (Tools.IsDevelopment()) console.log("SAVE SIZE GUIDE ITEM", SizeGuide);

      const sizeGuideResponse = await SizeGuideServices.PutSizeGuide(
        state.Id,
        SizeGuide
      );

      if (sizeGuideResponse && sizeGuideResponse.Status === 200) {
        if (sizeGuideResponse.Content) {
          setShowModal(true);
        } else {
          console.log("SAVE SIZE GUIDE RESPONSE ERROR", sizeGuideResponse);
        }
      } else {
        console.log("SAVE SIZE GUIDE RESPONSE ERROR", sizeGuideResponse);
      }
    } catch (error) {
      console.log("SAVE SIZE GUIDE ERROR", error);
    }
  };

  const onHideModal = () => {
    setShowModal(false);
    navigate(-1);
  };

  const clothesImages: { [key: string]: any } = {
    TOP: {
      FEMALE: {
        es: "img/topclothingfemes.png",
        en: "img/topclothingfemen.png",
        pt: "img/topclothingfempt.png",
      },
      MALE: {
        es: "img/topclothingmalees.png",
        en: "img/topclothingmaleen.png",
        pt: "img/topclothingmalept.png",
      },
      UNISEX: {
        es: "",
        en: "",
        pt: "",
      },
      UNKNOW: {
        es: "",
        en: "",
        pt: "",
      },
    },
    BOTTOM: {
      FEMALE: {
        es: "img/bottomclothingfemes.png",
        en: "img/bottomclothingfemen.png",
        pt: "img/bottomclothingfempt.png",
      },
      MALE: {
        es: "img/bottomclothingmalees.png",
        en: "img/bottomclothingmaleen.png",
        pt: "img/bottomclothingmalept.png",
      },
      UNISEX: {
        es: "",
        en: "",
        pt: "",
      },
      UNKNOW: {
        es: "",
        en: "",
        pt: "",
      },
    },
    ENTIRE: {
      FEMALE: {
        es: "img/fullclothingfemes.png",
        en: "img/fullclothingfemen.png",
        pt: "img/fullclothingfempt.png",
      },
      MALE: {
        es: "img/fullclothingmalees.png",
        en: "img/fullclothingmaleen.png",
        pt: "img/fullclothingmalept.png",
      },
      UNISEX: {
        es: "",
        en: "",
        pt: "",
      },
      UNKNOW: {
        es: "",
        en: "",
        pt: "",
      },
    },
    BRASSIERE: {
      FEMALE: {
        es: "img/brassieres.png",
        en: "img/brassieren.png",
        pt: "img/brassierpt.png",
      },
      MALE: {
        es: "",
        en: "",
        pt: "",
      },
      UNISEX: {
        es: "",
        en: "",
        pt: "",
      },
      UNKNOW: {
        es: "",
        en: "",
        pt: "",
      },
    },
    SHOES: {
      FEMALE: {
        es: "",
        en: "",
        pt: "",
      },
      MALE: {
        es: "",
        en: "",
        pt: "",
      },
      UNISEX: {
        es: "",
        en: "",
        pt: "",
      },
      UNKNOW: {
        es: "",
        en: "",
        pt: "",
      },
    },
  };

  const clothesTypeKey = E_ClothesType[clothesTypeSelect];
  const genderTypeKey = E_GenderType[genreSelect];

  return (
    <>
      <Row>
        <Col>
          <p className="font-fitprenda-title-crud">
            <FormattedMessage
              id="edit-size-guide-main-data"
              // defaultMessage="Datos principales"
            />
          </p>
        </Col>
      </Row>
      {/* Componente Datos Principales */}
      <Row>
        <Col xs={7}>
          <BlockContentControls children={contentAttibrutes()} />
        </Col>
        <Col xs={2}>
          <SuggestionWidget
            description={
              <FormattedMessage id="edit-size-guide-widget-use-name" />
            }
            title={<FormattedMessage id="edit-size-guide-widget-use-title" />}
          />
        </Col>
      </Row>
      {/* Titulo y parrafo Talles y medidas / Ingresa en cada campo.. */}
      <Row className="mt-4">
        <Col>
          <p className="font-fitprenda-title-crud">
            <FormattedMessage
              id="edit-size-guide-sizes-measures"
              defaultMessage="Talles y medidas"
            />
          </p>
        </Col>
      </Row>
      <Row>
        <Col className="font-fitprenda-subtitle-crud">
          <p>
            <FormattedMessage
              id="edit-size-guide-enterMeasurements"
              defaultMessage="Ingresa en cada campo las {boldText} de la siguiente forma: desde - hasta."
              values={{
                boldText: (
                  <b>
                    <FormattedMessage
                      id="edit-size-guide-bodyMeasurements"
                      defaultMessage="medidas corporales"
                    />
                  </b>
                ),
              }}
            />
          </p>
        </Col>
      </Row>
      <Row>
        {/* Componente de Talles Contornos y alto total */}
        <Col xs={7}>
          <BlockContentControls paddingX={5} children={contentSizes()} />
        </Col>
        {/* Sugerencias Al lado de talles y medidas */}
        <Col xs={2}>
          <SuggestionWidget
            styleClass="mb-2"
            title={
              clothesTypeSelect !== E_ClothesType.BRASSIERE ? (
                <FormattedMessage id="edit-size-guide-widget-use-title" />
              ) : (
                <FormattedMessage
                  id="edit-size-guide-contornoBusto"
                  defaultMessage="Contorno busto"
                />
              )
            }
            description={
              clothesTypeSelect !== E_ClothesType.BRASSIERE ? (
                <FormattedMessage
                  id="edit-size-guide-thinkBodyMeasurements"
                  defaultMessage="Pensar en Medidas corporales"
                />
              ) : (
                <FormattedMessage
                  id="edit-size-guide-bustContour"
                  defaultMessage="Todo el contorno rodeando la espalda, justo en el medio del busto."
                />
              )
            }
          />
          <SuggestionWidget
            title={
              clothesTypeSelect !== E_ClothesType.BRASSIERE ? (
                <FormattedMessage id="edit-size-guide-widget-use-title" />
              ) : (
                <FormattedMessage
                  id="edit-size-guide-bajoBusto"
                  defaultMessage="Bajo busto"
                />
              )
            }
            description={
              clothesTypeSelect !== E_ClothesType.BRASSIERE ? (
                <FormattedMessage
                  id="edit-size-guide-considerElasticity"
                  defaultMessage="Tener en cuenta la elasticidad de la prenda"
                />
              ) : (
                <FormattedMessage
                  id="edit-size-guide-bustEndContour"
                  defaultMessage="Contorno del cuerpo justo abajo de donde termina el busto."
                />
              )
            }
          />
        </Col>
        {/* Imagenes Al lado de sugerencias */}
        <Col>
          {clothesTypeSelect && genreSelect ? (
            <img
              src={
                clothesImages[clothesTypeKey][genderTypeKey][
                  props.selectedLanguage
                ]
              }
              alt={""}
              width={280}
              className="size-guide-images"
            />
          ) : (
            ""
          )}
        </Col>
      </Row>
      {/* CODIFICACIONES */}
      <Row className="mt-4">
        <Col>
          <p className="font-fitprenda-title-crud">
            <FormattedMessage
              id="ready-size-edit-size-guide-other-codes"
              defaultMessage="Agregar otras codificaciónes"
            />
          </p>
        </Col>
      </Row>
      <Row>
        <Col className="font-fitprenda-subtitle-crud">
          <p>
            <FormattedMessage
              id="ready-size-edit-size-guide-other-codes-exp"
              defaultMessage="Ingresa en cada campo las {boldText} de la siguiente forma: desde - hasta."
              values={{
                boldText: (
                  <b>
                    <FormattedMessage
                      id="edit-size-guide-bodyMeasurements"
                      defaultMessage="medidas corporales"
                    />
                  </b>
                ),
              }}
            />
          </p>
          <TooltipAlias />
          {/* <Tooltip
            headingId="tooltip.heading2"
            paragraphIds={["tooltip.paragraph3", "tooltip.paragraph4"]}
            firstParagraphBackgroundColor="#8e5cf1"
            tooltipRight="-300px" // custom value
            tooltipWidth="300px" // custom value
            tooltipTop="-70px" // custom value
          /> */}
        </Col>
      </Row>
      <Row>
        {/* Componente de Talles Contornos y alto total */}
        <Col xs={7}>
          <BlockContentControls paddingX={5} children={contentAlias()} />
        </Col>
      </Row>

      {/* Aca va el componente de abajo de talles y contornos */}
      {/* <Row className="mt-5">
        <Col>
          <DataTableProducts products={products} />
        </Col>
      </Row> */}
      {/* Botones Cancelar y Guardar */}
      <Row className="mt-3">
        <Col xs={1} className="edit-size-guide-button">
          <ButtonCommon
            label={
              <FormattedMessage
                id="ready-size-Cancelar"
                defaultMessage="Cancel"
              />
            }
            isOutline={true}
            eventClick={() => onClickCancelar()}
            className="edit-size-guide-button"
          />
        </Col>
        <Col xs={1} className="edit-size-guide-button">
          <ButtonCommon
            label={
              <FormattedMessage id="ready-size-Guardar" defaultMessage="Save" />
            }
            isOutline={false}
            eventClick={() => onClickSave()}
          />
        </Col>
      </Row>
      {/* Modal Template */}
      <ModalActionMessage
        Title={"¡Guía modificada con éxito!"}
        Show={showModal}
        OnModalClose={onHideModal}
      />
      <br />
    </>
  );
};

export default EditSizeGuide;
